export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'PROFILE_TEMPLATE',
        data => ({
            id: data.id,
            language: data.language,
            degrees: data.degrees,
            studyPrograms: data.studyPrograms,
        }),
    ],
    authorize: true,
    POST: {},

    '/:id': {
        GET: {},
        PUT: {},
    },
};
